import { Airplane24Regular } from "@fluentui/react-icons/svg/airplane";
import { Beaker24Regular } from "@fluentui/react-icons/svg/beaker";
import { Bookmark24Regular } from "@fluentui/react-icons/svg/bookmark";
import { Briefcase24Regular } from "@fluentui/react-icons/svg/briefcase";
import { Calendar24Regular } from "@fluentui/react-icons/svg/calendar";
import { CheckmarkSquare24Regular } from "@fluentui/react-icons/svg/checkmark-square";
import { ClipboardTask24Regular } from "@fluentui/react-icons/svg/clipboard-task";
import { HatGraduation24Regular } from "@fluentui/react-icons/svg/hat-graduation";
import { Heart24Regular } from "@fluentui/react-icons/svg/heart";
import { Home24Regular } from "@fluentui/react-icons/svg/home";
import { Lightbulb24Regular } from "@fluentui/react-icons/svg/lightbulb";
import { PaintBrush24Regular } from "@fluentui/react-icons/svg/paint-brush";
import { Person24Regular } from "@fluentui/react-icons/svg/person";
import { Rocket24Regular } from "@fluentui/react-icons/svg/rocket";
import { ShoppingBag24Regular } from "@fluentui/react-icons/svg/shopping-bag";
import { Star24Regular } from "@fluentui/react-icons/svg/star";
import { Target24Regular } from "@fluentui/react-icons/svg/target";
import { TaskListSquareLtr24Regular } from "@fluentui/react-icons/svg/task-list-square-ltr";
import { TreeDeciduous24Regular } from "@fluentui/react-icons/svg/tree-deciduous";
import type { FluentIcon } from "@fluentui/react-icons";

export const DEFAULT_BOARD_ICON_ID = "tasks";

// Ids offered in the board icon picker, in display order.
export const BOARD_ICON_IDS = [
  "tasks",
  "work",
  "home",
  "personal",
  "launch",
  "goals",
  "planning",
  "research",
  "health",
  "favourites",
  "ideas",
  "saved",
  "checklist",
  "shopping",
  "paint",
  "graduation",
  "plane",
  "tree",
  "clipboard",
] as const;

// Icon for every id a board can be stored with: the pickable ids above, plus
// legacy FontAwesome ids from boards created before the icon picker was added.
export const BOARD_ICON_MAP: Record<string, FluentIcon> = {
  tasks: ClipboardTask24Regular,
  "fa-tasks": ClipboardTask24Regular, // ?
  work: Briefcase24Regular,
  "fa-briefcase": Briefcase24Regular,
  home: Home24Regular,
  "fa-home": Home24Regular,
  personal: Person24Regular,
  launch: Rocket24Regular,
  goals: Target24Regular,
  planning: Calendar24Regular,
  research: Beaker24Regular,
  "fa-flask": Beaker24Regular,
  health: Heart24Regular,
  favourites: Star24Regular,
  ideas: Lightbulb24Regular,
  saved: Bookmark24Regular,
  checklist: CheckmarkSquare24Regular,
  "fa-check-square": CheckmarkSquare24Regular, // ?
  shopping: ShoppingBag24Regular,
  "fa-shopping-basket": ShoppingBag24Regular, // ?
  paint: PaintBrush24Regular,
  "fa-paint-brush": PaintBrush24Regular, // ?
  graduation: HatGraduation24Regular,
  "fa-graduation-cap": HatGraduation24Regular, // ?
  plane: Airplane24Regular,
  "fa-plane": Airplane24Regular, // ?
  tree: TreeDeciduous24Regular,
  "fa-tree": TreeDeciduous24Regular, // ?
  clipboard: TaskListSquareLtr24Regular,
  "fas fa-clipboard-list": ClipboardTask24Regular,
};

export function getBoardIcon(id: string): FluentIcon | undefined {
  return BOARD_ICON_MAP[id?.toLowerCase()];
}

export function normaliseBoardIcon(storedValue: string): string {
  return getBoardIcon(storedValue) ? storedValue : DEFAULT_BOARD_ICON_ID;
}
